import React, { useEffect, useRef, useState } from "react";
import useActiveSection from "../../utils/use-active-section";
import SideNav from "../content-page/SideNav";
import "./legal-page.css";

const LegalPage = ({ title, children }) => {
  const contentRef = useRef(null);
  const [sections, setSections] = useState([]);
  const [activeId, goTo] = useActiveSection(
    sections.map((section) => section.id),
  );

  useEffect(() => {
    const headings = Array.from(contentRef.current.querySelectorAll("h2"));
    headings.forEach((heading, index) => {
      heading.id = `legal-section-${index + 1}`;
    });
    setSections(
      headings.map((heading) => ({
        id: heading.id,
        title: heading.textContent.trim(),
      })),
    );
  }, []);

  return (
    <section className="legal-page content-page">
      <div className="legal-hero">
        <div className="legal-hero__inner">
          <h1 className="legal-hero__title">{title}</h1>
        </div>
      </div>
      <div className="content-page__layout">
        <SideNav
          label={`${title} sections`}
          heading="On this page"
          items={sections}
          activeId={activeId}
          onSelect={goTo}
        />
        <article className="legal-content" ref={contentRef}>
          {children}
        </article>
      </div>
    </section>
  );
};

export default LegalPage;
